import React from 'react';
import styled from '@emotion/styled';
import { ArrowButton, TextButton } from '../../../../ui';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { ActionsRow } from '../../../shared/account/details/ui/layout/ActionsRow';
import { useDetailsFormContext } from '../../../shared/account/details/hooks/useDetailsFormContext';
import { DELETE_ACCOUNT_DIALOG_HASH } from '../../../auth/delete-account/ui/DeleteAccountDialog';
import { LinkTextNoDecoration } from '../../../shared/components';
import DeleteIcon from '../../../../../assets/icons/delete.svg?reference';

export const AccountDetailsSubmit = () => {
	const { t } = useTranslation();
	const {
		formState: { isSubmitting },
	} = useDetailsFormContext();

	return (
		<ActionsRow columns={[2, { mobileXL: 1 }]}>
			<LinkTextNoDecoration href={DELETE_ACCOUNT_DIALOG_HASH}>
				<img
					src={DeleteIcon}
					alt={t('user_delete_account_label')}
					aria-label={t('user_delete_account_label')}
				/>
				<StyledTextButton variant="error">
					{t('user_delete_account_label')}
				</StyledTextButton>
			</LinkTextNoDecoration>
			<ArrowButton type="submit" disabled={isSubmitting}>
				{t('user_modify_personal_details_submit_button')}
			</ArrowButton>
		</ActionsRow>
	);
};

const StyledTextButton = styled(TextButton.withComponent('span'))``;
